<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section attention" id="attention">
    <!-- <div id="scrollArea"></div> -->
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">ATTENTION</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <Wrapper>
            <ul>
              <li v-for="item in items" :key="item.id">
                <p>
                  <font-awesome-icon
                    v-observe-visibility="{
                      callback: visibilityChanged,
                    }"
                    :class="{isVisible}" 
                    :prefix="item.prefix" :icon="item.icon"/>
                    {{ item.message1 }}<span class="strong" :class="{strongFont: isIntersecting}">{{ item.strong}}</span>{{ item.message2 }}
                </p>
              </li>
            </ul>
          </Wrapper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Wrapper from './Wrapper'
export default {
  name: 'attention',
  components: {
    Wrapper,
  },
  data(){
    return {
      isJump: false,
      isVisible: false,
      isIntersecting: false,
      items: [
        { id: 1, prefix: 'fas', icon: 'phone-square', message1: '事前予約制でございます。', strong: '', message2: ''},
        { id: 2, prefix: 'fas', icon: 'syringe', message1: '', strong: '１年以内の', message2: '５種以上の混合ワクチン証明書・狂犬病証明書が必須です。'},
        { id: 3, prefix: 'fas', icon: 'clinic-medical', message1: '予防接種後', strong:'１週間以上', message2: 'の間隔を空けてご利用ください。'},
        { id: 4, prefix: 'fas', icon: 'dog', message1: '', strong:'定期的', message2: 'な健康診断受診が必要です。'},
        { id: 5, prefix: 'fas', icon: 'paw', message1: 'ノミ・ダニは事前に', strong: '病院にて駆除をお願いいたします。', message2: ''},
        { id: 6, prefix: 'fas', icon: 'cookie-bite', message1: '', strong: '噛みグセ・暴れてしまう',message2: 'などは事前相談ください。'},
        { id: 7, prefix: 'fas', icon: 'question-circle', message1: 'その他ご心配毎はご相談ください。', strong: '', message2: ''},
        { id: 8, prefix: 'fas', icon: 'dog', message1: '', strong: '大型犬', message2: 'の施術は行っておりません。'},
      ]
    }
  },
  computed: {
    // sample(id) {
    //   let a = this.items[id].icon1;
    //   let b = this.items[id].icon2;
    //   return [a, b]
    // }
  },
  methods: {
    visibilityChanged (isVisible) {
      this.isVisible = isVisible
    },
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  }
}

</script>

<style lang="scss">
.strong {
  font-weight: bold;
}

.jump {
  animation: jump-animation 1.0s ease-in-out 0s infinite normal;
}

@keyframes jump-animation {
  0% {transform: scaleY(0.9);}
  10% {transform: translateY(0px) scaleY(1.0);}
  25% {transform: translateY(-10px);}
  50% {transform: translateY(1px) scaleY(0.9);}
  75% {transform: translateY(-3px);}
  90% {transform: translateY(0px);}
  100% {transform: scaleY(0.9);}
}

.visible {
  background: #aaa;
}

.anim {
  opacity: 0;
}

@keyframes anim1 {
    from {
      transform: translateY(-100px);
      opacity: 0;
    }
    to  {
      transform: translateY(0);
      opacity: 1;
    }
  }

</style>
